import Call from '../Call';
import {objToQs} from '../Utils';

const Revenues = {
    getPage(page, filters) {
        return Call(`revenues/${page}?${objToQs(filters)}`);
    },

    getPeriod(filters) {
        return Call(`revenues/period?${objToQs(filters)}`);
    }
}

export default Revenues;


// WEBPACK FOOTER //
// ./src/services/API/components/Revenues.js